import { readPreferencesDocument } from "../store/personalData";

const failure = (message, code = "INVALID_RESPONSE") => Object.assign(new Error(message), { code });

function request(query, context, write = false) {
  if (!context.accessToken) throw failure("Sign in required", "42501");
  query = query.setHeader("Authorization", `Bearer ${context.accessToken}`);
  if (write) query = query.retry(false);
  return context.signal ? query.abortSignal(context.signal) : query;
}

function preferenceRow(value) {
  const data = Array.isArray(value) && value.length === 1 ? value[0] : value;
  if (!data || !Number.isSafeInteger(data.revision) || data.revision < 1) {
    throw failure("Invalid preferences response");
  }
  const document = readPreferencesDocument(data.document);
  if (!document) throw failure("Saved preferences are invalid", "INVALID_DOCUMENT");
  return { revision: data.revision, document };
}

export async function getPreferences(context) {
  const { data, error } = await request(context.client.from("user_preferences")
    .select("revision,document").maybeSingle(), context);
  if (error) throw error;
  return data ? preferenceRow(data) : null;
}

export async function savePreferences(context, revision, document) {
  const valid = readPreferencesDocument(document);
  if (revision !== null && (!Number.isSafeInteger(revision) || revision < 1)) {
    throw failure("Invalid preferences revision");
  }
  if (!valid) throw failure("Invalid preferences", "INVALID_DOCUMENT");
  const { data, error } = await request(context.client.rpc("save_preferences", {
    p_revision: revision,
    p_document: valid,
  }), context, true);
  if (error) throw error;
  return preferenceRow(data);
}

export function preferencesErrorMessage(error) {
  if (error?.code === "PT409") {
    return "Cloud preferences changed on another device. Sign out and back in to load the latest version; local preferences were kept.";
  }
  if (error?.code === "INVALID_DOCUMENT") {
    return "Saved cloud preferences are invalid. Your local preferences were kept.";
  }
  if (["42501", "PGRST301", "PGRST303"].includes(error?.code) || error?.status === 401) {
    return "Your session could not access cloud preferences. Sign in again; local preferences were kept.";
  }
  return "Cloud preference sync could not be confirmed. Your local preferences were kept. Sign out and back in to reconnect.";
}
